import { DeviceType } from '@/common/common.contants';

// matched in order of priority
const TABLET_PATTERNS = [
  /ipad/i,
  /tablet/i,
  /kindle/i,
  /silk/i,
  /playbook/i,
  /tizen.*t/i, // Samsung tablets
  /sm-t\d+/i, // Samsung Galaxy Tab (e.g. SM-T510)
  /android(?!.*mobile)/i, // Android without "mobile" = tablet
  /\brvd-\d/i, // some Huawei tablets
  /\bkfapwi\b/i, // Kindle Fire
];

const MOBILE_PATTERNS = [
  /iphone/i,
  /ipod/i,
  /android.*mobile/i, // Android with "mobile" = phone
  /windows phone/i,
  /blackberry/i,
  /bb\d+/i, // BlackBerry newer models
  /opera mini/i,
  /iemobile/i,
  /\bMeeGo.+NokiaBrowser/i, // Nokia MeeGo
  /palm/i,
  /\bsymbian\b/i,
  /\bwebos\b/i,
  /\bseries(40|60)\b/i, // Older Nokia
];

function matchesAny(ua: string, patterns: RegExp[]): boolean {
  return patterns.some((pattern) => pattern.test(ua));
}

export function detectDeviceType(userAgent: string = ''): DeviceType {
  if (!userAgent) return DeviceType.DESKTOP;

  // tablet before mobile — Android tablets also partially
  // match mobile patterns, so order is important here
  if (matchesAny(userAgent, TABLET_PATTERNS)) return DeviceType.TABLET;
  if (matchesAny(userAgent, MOBILE_PATTERNS)) return DeviceType.MOBILE;

  return DeviceType.DESKTOP;
}
